<template>
  <div class="BSrecord">
    
        <!-- 页面部分 -->
        <el-scrollbar class="machineWrap" style="height:100%;">
         
            <div class="mainWrao">
              
              <!-- 表格部分 -->
              <div class="tableWrap">        
                 <!-- 两个 柱形图 -->
                 <div  class="chartWrap">
                   <div id="myChart"></div>
                   <div id="myChart2"></div>
                 </div>
                <!-- 表格 -->
                <el-table
                  v-loading="loading"
                  :data="tableData"
                  style="width: 100%">
                  <el-table-column
                  class-name='merge'
                    :label="$t('EventRecord.tableTitle1')"
                    width="60">
                    <template slot-scope="scope">
                      <span v-if="$store.state.lang===1">{{scope.row.machineNameZh}}</span>
                      <span v-else>{{scope.row.machineNameEn}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    class-name='merge'
                    :label="$t('EventRecord.tableTitle2')"
                    width="60">
                    <template slot-scope="scope">
                      <span>{{scope.row.msgCode}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                  class-name='merge'
                    :label="$t('EventRecord.tableTitle3')"
                    >
                     <template slot-scope="scope">
                      <span v-if="$store.state.lang===1">{{scope.row.event}}</span>
                      <span v-else>{{scope.row.msgEn}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    class-name='merge'
                    :label="$t('EventRecord.tableTitle4')"
                    width="100">
                    <template slot-scope="scope">
                      <span>{{scope.row.group}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    class-name='merge'
                    :label="$t('EventRecord.tableTitle5')"
                    width="60">
                    <template slot-scope="scope">
                      <span>{{scope.row.em}}</span>
                    </template>
                  </el-table-column>
                  <!-- 表格中带图标的部分 -->
                  <el-table-column
                  class-name='merge'
                    :label="$t('EventRecord.tableTitle6')"
                    width="60">
                    <template slot-scope="scope">
                      <helpIcon style="color:#808080" v-if="scope.row.typeValue === 'MCOND'" class="typeIcon" title="" />
                      <messageIcon style="color:#7948ea;" v-else-if="scope.row.typeValue === 'INFO'" title="" class="typeIcon"/>
                      <alertIcon style="color:#f16a4d" v-else-if="scope.row.typeValue === 'ALM'" title="" class="typeIcon"/>
                      <closeIcon style="color:#d43030;" v-else-if="scope.row.typeValue === 'FLT'" title="" class="typeIcon"/>
                      <span style="margin-left: 10px" :class="{mcond: scope.row.typeValue === 'MCOND', info:scope.row.typeValue === 'INFO', alm:scope.row.typeValue === 'ALM',flt:scope.row.typeValue === 'FLT'}">{{ scope.row.typeValue }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                  class-name='merge'
                    prop="timeStamp"
                    :label="$t('EventRecord.tableTitle7')"
                    width="120"
                    >
                    <template slot-scope="scope">
                      <span>{{ scope.row.createTime | formatDate }}</span>
                    </template>
                  </el-table-column>

                   <el-table-column
                   class-name='merge'
                    prop="timeStamp"
                    :label="$t('EventRecord.tableTitle9')"
                    width="120"
                    >
                    <template slot-scope="scope">
                      <span>{{ scope.row.updateTime | formatDate }}</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column
                  class-name='merge'
                    :label="$t('EventRecord.tableTitle8')"
                    width="80"
                    align='center'>
                    <template slot-scope="scope" >
                      <span v-if="scope.row.updateTime !== null">
                        {{ parseInt((scope.row.updateTime - scope.row.createTime) / 1000) }}''
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
        </el-scrollbar>
    
  </div>
</template>

<script>

import { formatDate } from '../assets/js/date.js'
import helpIcon from "vue-material-design-icons/HelpCircle.vue"
import messageIcon from "vue-material-design-icons/MessageAlert.vue"
import alertIcon from "vue-material-design-icons/Alert.vue"
import closeIcon from "vue-material-design-icons/CloseCircle.vue"
import downloadIcon from "vue-material-design-icons/Download.vue"
export default {
  name: 'record',
  components: {
    helpIcon,
    messageIcon,
    alertIcon,
    closeIcon,
    downloadIcon
  },
  data () {
    return {
      // 图表
      barChart: null,
      barChart2: null,
      // Machine筛选条件
      condition1: null,
      // EventCode筛选条件
      eventCode: '',
      // type筛选条件
      typeId: '',
      // Group筛选条件
      groupId: '',
      // EM筛选条件
      emId: '',
      // 排序
      sort: '',
      // 筛选时间
      selectTime: [],
      startTime: '',
      endTime: '',
      types: [],
      eventCodes: [],
      groups: [],
      ems: [],
      Machines: [],
      factoryId: '',
      machineId: '',
      machineName: '',
      shopId: '',
      lineId: '',
      duration: '',
      // *********当前页数
      nowPage: 1,
      nowPageSize: 10,
      listTotal: null,
      // 表格数据
      tableData: [],
      // fal数据
      faultData: [],
      // alm数据
      alarmData: [],
      loading: true,
      seachLoading: false,
      // 时间快捷键
      pickerMinDate: '',
      // 七天日期选择
      timer: ''
    }
  },
  mounted() {
    this.$store.commit('authority' , this.$route.path)
    if (this.$route.params.factoryId != null && this.$route.params.factoryId != 'undefined') {
      this.condition1 = [this.$route.params.factoryId, this.$route.params.machineId]
      this.factoryId = this.$route.params.factoryId
      this.machineId = this.$route.params.machineId
      this.machineName = this.$route.params.machineName
    }
    if (localStorage.getItem('isMarketAccount') === '1') {
      this.condition1 = [2, 101]
      this.factoryId = '2'
      this.machineId = '101'
    }
    this.getId()
    
    // this.chartResize()
  },
  destroyed() {
    // clearInterval(this.resizeTimer)
    clearInterval(this.timer)
  },
  methods: {
    getId(){
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/getBigscreenMachine'
      }).then(function(res){
        if (res.data.success === 'false') {
          _this.$message.error(res.data.msg);
        }else{
          _this.machineId = res.data.machine.id
          _this.getEventRecord()
          _this.timing()
        }
      })
    },
    // 列表查询
    getEventRecord () {
      let _this = this
      this.axios({
        method: 'get',
        url: '/download/getSecondScreenMachine',
        params: {
          machineId: _this.machineId, // 机器的id
          limitNum: 10
        }
      }).then(function (res) {
        _this.tableData = res.data.rows
        _this.listTotal = res.data.total
        if (res.data.faultData != null) {
          document.getElementById("myChart").style.display="inline"
          _this.faultData = res.data.faultData
        }else {
          _this.faultData = null
          document.getElementById("myChart").style.display = "none"
        }
        if (res.data.alarmData != null) {
          document.getElementById("myChart2").style.display="inline"
          _this.alarmData = res.data.alarmData
        }else {
          _this.alarmData = null
          document.getElementById("myChart2").style.display = "none"
        }
        _this.initChart()
        _this.initChart2()
        _this.loading = false
      }).catch(function () {
        _this.loading = false
      })
    },
    // 图表初始化
    initChart(){
      let _this = this
      _this.codeArr = []
      _this.desArr = []
      _this.numArr = []
      for (const item of _this.faultData) {
        _this.codeArr.push(item.msgCode)
        _this.numArr.push(item.codeNum)
        if (this.$store.state.lang === 1) {
          _this.desArr.push(item.group + '-' + item.em +'-' + item.event)
        }else {
         if (item.msgEn !=null ){
            _this.desArr.push(item.group + '-' + item.em +'-' + item.msgEn)
          }else{
            _this.desArr.push(item.group + '-' + item.em )
          }  
        }
      }
      let timeTitle = ''
      if (this.selectTime != '' && this.selectTime != null) {
        let startTime = formatDate(new Date(this.selectTime[0]), 'yyyy-MM-dd hh:mm:ss')
        let endTime =  formatDate(new Date(this.selectTime[1]), 'yyyy-MM-dd hh:mm:ss')
        timeTitle = `${startTime} ~ ${endTime}`
        }
      this.barChart = this.$echarts.init(document.getElementById('myChart'))
      this.barChart.setOption({
          title: {
          text: _this.$t('EventRecord.chartTitle'),
          subtext: timeTitle
      },
      tooltip: {
          trigger: 'axis',
          axisPointer: {
              type: 'shadow'
          },
          formatter:function(params){
            let titleIndex = params[0].dataIndex
            let titleArr =  params[0].seriesName.split(',')
            
            return params[0].axisValue + '<br/>' +
                        titleArr[titleIndex] + ' : ' +
                        params[0].data
          }
      },
      grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
      },
      xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
      },
      yAxis: {
          type: 'category',
          data: _this.codeArr
      },
      series: [
          {
              name: _this.desArr,
              type: 'bar',
              itemStyle: {
                    normal: {color: '#085ba6'}
              },
              data: _this.numArr
          }
        ]
      })
    },
    initChart2(){
      let _this = this
      _this.codeArr = []
      _this.desArr = []
      _this.numArr = []
      for (const item of _this.alarmData) {
        _this.codeArr.push(item.msgCode)
        _this.numArr.push(item.codeNum)
         if (this.$store.state.lang === 1) {
          _this.desArr.push(item.group + '-' + item.em +'-' + item.event)
        }else {
          if (item.msgEn !== null ){
            _this.desArr.push(item.group + '-' + item.em +'-' + item.msgEn)
          }else{
            _this.desArr.push(item.group + '-' + item.em)
          }  
        }
      }
      let timeTitle = ''
      if (this.selectTime != '' && this.selectTime != null) {
        let startTime = formatDate(new Date(this.selectTime[0]), 'yyyy-MM-dd hh:mm:ss')
        let endTime =  formatDate(new Date(this.selectTime[1]), 'yyyy-MM-dd hh:mm:ss')
        timeTitle = `${startTime} ~ ${endTime}`
        }
      this.barChart2 = this.$echarts.init(document.getElementById('myChart2'))
      this.barChart2.setOption({
          title: {
          text: _this.$t('EventRecord.chartTitle2'),
          subtext: timeTitle
      },
      tooltip: {
          trigger: 'axis',
          axisPointer: {
              type: 'shadow'
          },
          formatter:function(params){
            let titleIndex = params[0].dataIndex
            let titleArr =  params[0].seriesName.split(',')
            
            return params[0].axisValue + '<br/>' +
                        titleArr[titleIndex] + ' : ' +
                        params[0].data
          }
      },
      grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
      },
      xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
      },
      yAxis: {
          type: 'category',
          data: _this.codeArr
      },
      series: [
          {
              name: _this.desArr,
              type: 'bar',
              itemStyle: {
                    normal: {color: '#085ba6'}
              },
              data: _this.numArr
          }
        ]
      })
    },
    // 图表自动修正大小
    // chartResize(){
    //   let _this = this
    //   this.resizeTimer = setInterval(function(){
    //     if (_this.barChart !== null && _this.barChart2 !== null) {
    //       _this.barChart.resize()
    //       _this.barChart2.resize()
    //     }
    //   },500)
    // },
    //定时刷新数据
    timing(){
      let _this = this
      this.timer=setInterval(function(){
        _this.getEventRecord()
      },60000)
    }
  },
  filters: {
    formatDate (time) {
      if (time === null || time === '') {
        return ''
      }
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  },
}
</script>
<style scoped>
.machineWrap{
   height: 100%;
}
.BSrecord{
  height: 100%;
}
.mainWrao{
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  padding-bottom: 35px;
  border-radius: 4px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  display: inline-block;
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
}
.recordTitle div a {
  margin-left: 20px;
  color: #6bb4df;
}
.selectGroup{
  width: 105px;
}
.tableWrap{
  padding: 1px 1rem;
}
.titleRow label{
  font-size: 12px;
}
.datePick{
  margin: 25px 0;
}
.datePick .btns{
  float: right;
}
.typeIcon{
  color: #6772e5;
}
.pagination{
  text-align: center;
  margin-top: 35px;
}
.mcond{
  color:#808080
}
.info{
  color:#7948ea;
}
.alm{
  color:#f16a4d
}
.flt{
  color:#d43030;
}
.chartWrap{
  width: 100%;
  display: flex;
  margin: 1rem 0;
}
.chartWrap div{
  width: 50%;
  height: 17rem;
  margin: 0 5%;
}
.merge span, .merge .cell{
  font-size: 1.5rem;
}

</style>

